import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'
import { Toast } from 'src/app/domain/interfaces/components/toast.interface'

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  public toastSubject: Subject<Toast> = new Subject()
  public loadingToastSubject: Subject<string | null> = new Subject()

  public sendToast(toast: Toast): void {
    this.toastSubject.next(toast)
  }

  public showLoadingToast(message: string): void {
    this.loadingToastSubject.next(message)
  }

  public hideLoadingToast(): void {
    this.loadingToastSubject.next(null)
  }
}
